// @flow
import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import LazyLoad from 'react-lazyload';
import Highlighter from 'react-highlight-words';
import Helper from '../../../helper/Helper';
import CONFIG from '../../../config';
import I18n from '../../../i18n/I18n';
import { Checkbox, Icon, ProductNameBox, LocaleLink } from '../../common';
import ProductListBox from '../productListBox/ProductListBox';
import styles from './ProductTable.scss';

const ProductTable = (props: Object) => {
    const { data, searchString } = props;

    const offersNav = psku_canonical => {
        props.onOfferSelect
            ? props.onOfferSelect(psku_canonical)
            : props.history.push(
                  `${Helper.getAppDomain(
                      'catalog',
                  )}/${Helper.getLocale()}/catalog/${psku_canonical}`,
              );
    };

    const toggleCheckbox = offerId => {
        // e.stopPropagation();
        props.toggleCheckbox(offerId);
    };

    const placeholder = (
        <img
            src={`${CONFIG.BASE_IMG_URL}nr/misc/product-image-default.jpg`}
            alt="Placeholder"
        />
    );

    const offerList = data
        ? data.map((offer, index) => {
              const stockList =
                  offer && offer.stock_in
                      ? offer.stock_in.map((eachStock, stockInd) => {
                            return (
                                <div>
                                    <strong>{eachStock.country_code}</strong>:{' '}
                                    {eachStock.stock_available}
                                </div>
                            );
                        })
                      : '';

              return (
                  <tr
                      valign="center"
                      className={
                          props.selectedOffers.includes(offer.id_offer)
                              ? styles.selected
                              : ''
                      }
                      key={index + 'A'}
                  >
                      <td>
                          <Checkbox
                              checked={props.selectedOffers.includes(
                                  offer.id_offer,
                              )}
                              onClick={() => toggleCheckbox(offer.id_offer)}
                              name={`list${index}`}
                          />
                      </td>
                      <td className={styles.nameWrapper}>
                          <a
                              href={`${Helper.getAppDomain(
                                  'catalog',
                              )}/${Helper.getLocale()}/catalog/${
                                  offer.psku_canonical
                              }`}
                          >
                              <ProductNameBox
                                  hideBadge
                                  data={offer}
                                  searchString={searchString}
                              />
                          </a>
                      </td>
                      <td onClick={() => offersNav(offer.psku_canonical)}>
                          {offer.partner_sku_unique || offer.partner_sku ? (
                              <Highlighter
                                  highlightClassName={styles.highlight}
                                  searchWords={[searchString]}
                                  autoEscape={true}
                                  textToHighlight={
                                      offer.partner_sku_unique ||
                                      offer.partner_sku
                                  }
                              />
                          ) : (
                              '-'
                          )}
                      </td>
                      <td onClick={() => offersNav(offer.psku_canonical)}>
                          <Highlighter
                              highlightClassName={styles.highlight}
                              searchWords={[searchString]}
                              autoEscape={true}
                              textToHighlight={offer.sku}
                          />
                      </td>
                      <td onClick={() => offersNav(offer.psku_canonical)}>
                          {stockList}
                      </td>
                      <td
                          className={styles.price}
                          onClick={() => offersNav(offer.psku_canonical)}
                      >
                          {false && (
                              <strong>
                                  {I18n.getText('transfers.crossdock-b2b')}
                              </strong>
                          )}
                          <div
                              className={offer.sale_price ? styles.strike : ''}
                          >
                              {I18n.formatCurrency(
                                  Helper.formatPrice(
                                      offer.price,
                                      props.currencyCode,
                                  ),
                              )}
                          </div>

                          {offer.sale_price ? (
                              <div>
                                  {I18n.formatCurrency(
                                      Helper.formatPrice(
                                          offer.sale_price,
                                          props.currencyCode,
                                      ),
                                  )}
                              </div>
                          ) : (
                              ''
                          )}
                          {offer.has_fbn_stock && false ? (
                              <div style={{ marginTop: 10 }}>
                                  <strong>
                                      {I18n.getText('products.noon-now')}
                                  </strong>
                                  <div
                                      className={
                                          offer.sale_price_fbn
                                              ? styles.strike
                                              : ''
                                      }
                                  >
                                      {I18n.formatCurrency(
                                          Helper.formatPrice(
                                              offer.price_fbn,
                                              props.currencyCode,
                                          ),
                                      )}
                                  </div>

                                  {offer.sale_price_fbn ? (
                                      <div>
                                          {I18n.formatCurrency(
                                              Helper.formatPrice(
                                                  offer.sale_price_fbn,
                                                  props.currencyCode,
                                              ),
                                          )}
                                      </div>
                                  ) : (
                                      ''
                                  )}
                              </div>
                          ) : (
                              ''
                          )}
                      </td>
                      <td
                          style={{ direction: 'ltr' }}
                          onClick={() => offersNav(offer.psku_canonical)}
                      >
                          {offer.updated_at
                              ? moment(offer.updated_at).format(
                                    `YYYY-MM-DD [${
                                        props.lang === 'ar' ? '' : 'at'
                                    }] h:mm:ss a`,
                                )
                              : ''}
                      </td>
                      <td>
                          <div
                              className={
                                  Number(offer.is_active)
                                      ? styles.active
                                      : styles.inactive
                              }
                              onClick={() => offersNav(offer.psku_canonical)}
                          >
                              {Number(offer.is_active)
                                  ? I18n.getText(
                                        'product-table.active',
                                        {},
                                        'Active',
                                    )
                                  : I18n.getText(
                                        'product-table.inactive',
                                        {},
                                        'Inactive',
                                    )}
                          </div>
                      </td>
                  </tr>
              );
          })
        : '';

    const offerListBoxView = data
        ? data.map((offer, index) => {
              return (
                  <div className={styles.boxWrapper} key={index + 'box'}>
                      <ProductListBox
                          offer={offer}
                          checked={props.selectedOffers.includes(
                              offer.id_offer,
                          )}
                          onClickCheckbox={() => toggleCheckbox(offer.id_offer)}
                          offersNav={offersNav}
                          currencyCode={props.currencyCode}
                          index={index}
                          lang={props.lang}
                      />
                  </div>
              );
          })
        : '';

    const dir = props.dir && props.dir === 'asc' ? 'desc' : 'asc';

    return (
        <div className={styles.ctr}>
            {props.browser &&
            props.browser.greaterThan.tablet &&
            props.view === 'grid' ? (
                <table className={styles.table}>
                    <thead>
                        <tr className={`${styles.row} ${styles.head}`}>
                            <th>
                                <Checkbox
                                    defaultChecked={props.allSelected}
                                    checked={props.allSelected}
                                    onClick={() => props.selectAll()}
                                    indeterminate={props.indeterminate}
                                    name={'head'}
                                />
                            </th>
                            <th>
                                {I18n.getText('product-table.name', {}, 'Name')}
                            </th>
                            <th
                                className={styles.titleFlexer}
                                onClick={() =>
                                    props.sortColumn('partner_sku', dir)
                                }
                            >
                                {I18n.getText(
                                    'product-table.p-sku',
                                    {},
                                    'Partner SKU',
                                )}
                                {props.keyVal === 'partner_sku' ? (
                                    <Icon
                                        name={
                                            dir === 'asc'
                                                ? 'caret-down'
                                                : 'caret-up'
                                        }
                                    />
                                ) : (
                                    <Icon name={'caret-both'} />
                                )}
                            </th>
                            <th
                                className={styles.titleFlexer}
                                onClick={() => props.sortColumn('sku', dir)}
                            >
                                {I18n.getText('product-table.sku', {}, 'SKU')}
                                {props.keyVal === 'sku' ? (
                                    <Icon
                                        name={
                                            dir === 'asc'
                                                ? 'caret-up'
                                                : 'caret-down'
                                        }
                                    />
                                ) : (
                                    <Icon name={'caret-both'} />
                                )}
                            </th>
                            <th
                                className={styles.titleFlexer}
                                onClick={() =>
                                    props.sortColumn('stock_available', dir)
                                }
                            >
                                {I18n.getText(
                                    'product-table.stock',
                                    {},
                                    'Stock',
                                )}
                                {props.keyVal === 'stock_available' ? (
                                    <Icon
                                        name={
                                            dir === 'asc'
                                                ? 'caret-up'
                                                : 'caret-down'
                                        }
                                    />
                                ) : (
                                    <Icon name={'caret-both'} />
                                )}
                            </th>
                            <th
                                className={styles.titleFlexer}
                                onClick={() => props.sortColumn('price', dir)}
                            >
                                {I18n.getText(
                                    'product-table.price',
                                    {},
                                    'Price',
                                )}
                                {props.keyVal === 'price' ? (
                                    <Icon
                                        name={
                                            dir === 'asc'
                                                ? 'caret-up'
                                                : 'caret-down'
                                        }
                                    />
                                ) : (
                                    <Icon name={'caret-both'} />
                                )}
                            </th>
                            <th
                                className={styles.titleFlexer}
                                onClick={() =>
                                    props.sortColumn('updated_at', dir)
                                }
                            >
                                {I18n.getText(
                                    'product-table.updated',
                                    {},
                                    'Updated At',
                                )}
                                {props.keyVal === 'updated_at' ? (
                                    <Icon
                                        name={
                                            dir === 'asc'
                                                ? 'caret-up'
                                                : 'caret-down'
                                        }
                                    />
                                ) : (
                                    <Icon name={'caret-both'} />
                                )}
                            </th>
                            <th>
                                {I18n.getText(
                                    'product-table.status',
                                    {},
                                    'Status',
                                )}
                            </th>
                        </tr>
                    </thead>
                    <tbody>{offerList}</tbody>
                </table>
            ) : (
                offerListBoxView
            )}
        </div>
    );
};

export default ProductTable;



// WEBPACK FOOTER //
// ./src/components/products/productTable/ProductTable.js